var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.01002L7.01 8.99902",
    stroke: "#007FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.01002L11.01 8.99902",
    stroke: "#007FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.01L7.01 12.999",
    stroke: "#007FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.01L11.01 12.999",
    stroke: "#007FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.01L7.01 16.999",
    stroke: "#007FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.01L11.01 16.999",
    stroke: "#007FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17H17M15 21H3.6C3.44087 21 3.28826 20.9368 3.17574 20.8243C3.06321 20.7117 3 20.5591 3 20.4V5.6C3 5.44087 3.06321 5.28826 3.17574 5.17574C3.28826 5.06321 3.44087 5 3.6 5H9V3.6C9 3.44087 9.06321 3.28826 9.17574 3.17574C9.28826 3.06321 9.44087 3 9.6 3H14.4C14.5591 3 14.7117 3.06321 14.8243 3.17574C14.9368 3.28826 15 3.44087 15 3.6V9V21ZM15 21H20.4C20.5591 21 20.7117 20.9368 20.8243 20.8243C20.9368 20.7117 21 20.5591 21 20.4V9.6C21 9.44087 20.9368 9.28826 20.8243 9.17574C20.7117 9.06321 20.5591 9 20.4 9H15V21ZM15 21V17V21ZM15 9V13V9ZM15 13H17H15ZM15 13V17V13Z",
    stroke: "#007FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.da4092e204f45b04c57dd9768e365678.svg";
export { ForwardRef as ReactComponent };